import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface CategorySelectorProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <FormControl fullWidth required>
      <InputLabel id="category-label">Category</InputLabel>
      <Select
        labelId="category-label"
        label="Category"
        value={selectedCategory}
        onChange={(e: any) => onCategoryChange(e.target.value)}
        // onBlur={() => setTouchedFields(prev => ({ ...prev, monthlyMarketingSpend: true }))}
        fullWidth
        sx={{
          height: '56px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {categories.map((option, index) => (
          <MenuItem key={`${index}--${option}`} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CategorySelector;
